import { useState, useCallback, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const animateBannersIn = () => {
  const banners = Array.from({ length: 5 }, (_, i) => 
    document.getElementById(`banner-${i + 1}`)
  ).filter(Boolean);

  banners.forEach((banner, index) => {
    banner.style.transform = "translateY(0%)";
    banner.style.transition = `transform 0.6s ease-in-out ${index * 0.1}s`;
  });
};

const animateBannersOut = () => {
  const banners = Array.from({ length: 5 }, (_, i) => 
    document.getElementById(`banner-${i + 1}`)
  ).filter(Boolean);

  banners.forEach((banner, index) => {
    banner.style.transform = "translateY(-100%)";
    banner.style.transition = `transform 0.6s ease-in-out ${(4 - index) * 0.1}s`;
  });
};

const resetBanners = () => {
  const banners = Array.from({ length: 5 }, (_, i) => 
    document.getElementById(`banner-${i + 1}`)
  ).filter(Boolean);

  banners.forEach((banner) => {
    banner.style.transform = "translateY(-100%)";
    banner.style.transition = "none";
  });
};

export const usePageTransition = () => {
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [targetUrl, setTargetUrl] = useState(null);
  const [hasInitialLoad, setHasInitialLoad] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Trigger transition on initial page load
  useEffect(() => {
    if (!hasInitialLoad) {
      setHasInitialLoad(true);
      setIsTransitioning(true);
      setTargetUrl(location.pathname);

      resetBanners();
      animateBannersIn();

      setTimeout(() => {
        animateBannersOut();
        setTimeout(() => {
          setIsTransitioning(false);
          setTargetUrl(null);
          resetBanners();
        }, 800); // exit duration
      }, 800); // visible duration
    }
  }, [hasInitialLoad, location.pathname]);

  const startTransition = useCallback(
    (url) => {
      setIsTransitioning(true);
      setTargetUrl(url);

      resetBanners();
      animateBannersIn();

      if (url) navigate(url);

      setTimeout(() => {
        animateBannersOut();
        setTimeout(() => {
          setIsTransitioning(false);
          setTargetUrl(null);
          resetBanners();
        }, 800);
      }, 800);
    },
    [navigate]
  );

  return { isTransitioning, targetUrl, startTransition };
};
